import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  reportId: string;
};

export const adminGetReportDuplicates = createQueryFn(
  QueryNameSpace.adminGetReportDuplicates,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    const res = await DigiobcanApi.adminGetReportDuplicates(params.reportId);
    return res.duplicates;
  },
);
